import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__